// Avoid as possible chaning Tab enum values, this value is saved in users state.
import { TableKeys } from '@communication-center/data-objects';

export const TabsConfig = {
    [TableKeys.ACTIVE]: {
        label: 'Active',
        tableKey: TableKeys.ACTIVE
    },
    [TableKeys.SCHEDULED]: {
        label: 'Scheduled',
        tableKey: TableKeys.SCHEDULED
    },
    [TableKeys.SENT]: {
        label: 'Completed',
        tableKey: TableKeys.SENT
    },
    [TableKeys.DRAFTS]: {
        label: 'Drafts',
        tableKey: TableKeys.DRAFTS
    },
    [TableKeys.ARCHIVED]: {
        label: 'Archived',
        tableKey: TableKeys.ARCHIVED
    }
};

export enum TemplateTabs {
    Featured = 'Featured',
    Custom = 'Custom'
}
